// import React, { useState, useEffect } from "react";
// import Header from "./header/header";
// import LoginModal from "./login/login";

// const App = () => {
//   const [isLoggedIn, setIsLoggedIn] = useState(false);

//   useEffect(() => {
//     const loginStatus = localStorage.getItem("isLoggedIn");
//     if (loginStatus === "true") {
//       setIsLoggedIn(true);
//     }
//   }, []);

//   const handleLogin = () => {
//     setIsLoggedIn(true);
//     localStorage.setItem("isLoggedIn", "true");
//   };

//   return (
//     <div>
//       {!isLoggedIn && <LoginModal onLogin={handleLogin} />}
//       {isLoggedIn && <Header />}
//     </div>
//   );
// };

// export default App;

import React, { useState, useEffect } from "react";
import Header from "./header/header";
import LoginModal from "./login/login";
import Table from "./table/table";

const App = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const loginStatus = localStorage.getItem("isLoggedIn");
    if (loginStatus === "true") {
      setIsLoggedIn(true);
    }
  }, []);

  const handleLogin = () => {
    setIsLoggedIn(true);
    localStorage.setItem("isLoggedIn", "true");
  };
  const handleLogout = () => {
    localStorage.removeItem("isLoggedIn");
    localStorage.removeItem("useremail");
    localStorage.removeItem("userpassword");
    setIsLoggedIn(false);
  };

  return (
    <div>
      {!isLoggedIn && <LoginModal onLogin={handleLogin} />}
      {/* {isLoggedIn && <Header />} */}
      {isLoggedIn && <Header onLogout={handleLogout} />}
      {isLoggedIn && <Table />}
    </div>
  );
};

export default App;
